import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { usePageTitle } from '@/hooks/usePageTitle';
import { ItemSelectionPanel } from '../components/ItemSelectionPanel';
import { picklistService } from '../services';
import type { CreatePicklistItemRequest } from '../types';

export function PicklistCreationPage() {
  usePageTitle('Create Picklist');
  const navigate = useNavigate();

  const handleCreate = async (items: CreatePicklistItemRequest[]) => {
    const result = await picklistService.create({ items });

    toast.success('Picklist Created', {
      description: `Picklist ${result.picklistNumber} created with ${result.totalItems} item${result.totalItems !== 1 ? 's' : ''}`,
      duration: 5000,
      action: {
        label: 'View',
        onClick: () => navigate(`/mro/issuance/picklist/${result.id}`),
      },
    });
  };

  return (
    <ItemSelectionPanel
      title="Create Picklist"
      backPath="/mro/issuance"
      submitLabel="Create Picklist"
      submittingLabel="Creating..."
      confirmTitle="Confirm Picklist Creation"
      confirmDescription="Review what will be picked, then create the picklist."
      confirmButtonLabel="Create Picklist"
      onSubmit={handleCreate}
    />
  );
}
